import { IApplicationEnvironment } from 'environments/application-environment.interface';

export const environment: IApplicationEnvironment = {
  production: true,
  name: 'production',
  version: '1.9.14',
  baseUrl: '', // value is defined by env.json
  envFile: 'env.json',
  logLevel: 'warn',
  shortLifeCache: 10000,
  authenticationServer: '', // value is defined by env.json
  allowedUrls: [], // value is defined by env.json
  apiVersion: 1,
  environmentName: '',
  environmentBannerColor: '',
  defaultPageSize: 0,
  scope: '',
};

export const apiUrl = () => {
  return `${environment.baseUrl}/api/v${environment.apiVersion}`;
};